<div class="modal-container">
  <div class="modal-backdrop"></div>
  <div
    class="payout-graph-data resize-able"
    appResizerHorizontal
    appResizerVertical
    [minWidth]="750"
    [minHeight]="
      chartOptions?.series || isLoading ? minHeightPostData : minHeightPreData
    "
    [style.min-height]="
      chartOptions?.series || isLoading
        ? minHeightPostData + 'px'
        : minHeightPreData + 'px'
    "
  >
    <div class="modal-header">
      Payout Graph
      <cds-icon (click)="modalChanged(false)" shape="window-close" size="24">
      </cds-icon>
    </div>
    <div class="body">
      @if (commonCrossProducts?.length) {
        <form [formGroup]="form" class="horizontal-grid">
          <div>Currency Pair</div>
          <div>Spot Ref</div>
          <div>Range</div>
          <div>Graph Currency</div>
          <div>Premium Currency</div>
          <div>
            {{ commonCross }}
          </div>
          <div>
            <clr-input-container>
              <input
                class="number-input"
                clrInput
                type="number"
                id="spot"
                formControlName="spot"
              />
            </clr-input-container>
          </div>

          <div>
            <clr-input-container>
              <input
                class="number-input"
                clrInput
                type="number"
                id="lowerBoundary"
                formControlName="lowerBoundary"
              />
            </clr-input-container>
            <span class="range-dash"> - </span>
            <clr-input-container>
              <input
                class="number-input"
                clrInput
                type="number"
                id="upperBoundary"
                formControlName="upperBoundary"
              />
            </clr-input-container>
          </div>
          <div>
            <clr-select-container>
              <select clrSelect formControlName="graphCurrency">
                <option [value]="baseCurrency">
                  {{ baseCurrency }}
                </option>
                <option [value]="counterCurrency">
                  {{ counterCurrency }}
                </option>
              </select>
            </clr-select-container>
          </div>
          <div>
            <clr-select-container>
              <select clrSelect formControlName="premiumCurrency">
                <option [value]="baseCurrency">
                  {{ baseCurrency }}
                </option>
                <option [value]="counterCurrency">
                  {{ counterCurrency }}
                </option>
              </select>
            </clr-select-container>
          </div>
        </form>
        <div
          *ngIf="isLoading || chartOptions?.series"
          class="expanded-graph-container"
        >
          @if (isLoading) {
            <span class="spinner spinner-inverse"> </span>
          } @else {
            @if (chartOptions.series) {
              <ag-charts
                style="width: 100%; height: 100%"
                [options]="chartOptions"
              >
              </ag-charts>
            }
          }
        </div>
      } @else {
        <span> No currency pair found </span>
      }
    </div>

    <div class="modal-footer">
      <button type="button" class="ui-button" (click)="modalChanged(false)">
        Close
      </button>

      <button
        type="button"
        class="ui-button primary"
        (click)="submit()"
        [disabled]="!commonCrossProducts?.length || !form.valid"
      >
        Calculate
      </button>
    </div>
  </div>
</div>
